import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import ChecklistResultScreen from '../components/checklist/ChecklistResultScreen';

/**
 * Тестовая страница вёрстки финального экрана чек-листа (Figma 2318:1490).
 * Без подключения к логике опроса — только UI preview.
 */
const ChecklistResultPreviewPage = () => (
  <div className="flex min-h-screen flex-col">
    <SEOHead
      title="Превью: результат чек-листа | Антология"
      description="Тестовая вёрстка экрана результатов чек-листа готовности к AI"
      canonical="https://antologia.tech/ready-for-ai/result-preview"
      noindex
    />
    <Header />
    <main className="flex-1 px-4 py-10 sm:px-6 lg:px-8" style={{ paddingTop: '5rem' }}>
      <p className="mx-auto mb-6 max-w-[672px] text-center text-sm text-muted-foreground">
        Тестовая вёрстка по макету Figma. Логика и API не подключены.
      </p>
      <ChecklistResultScreen />
    </main>
    <Footer />
  </div>
);

export default ChecklistResultPreviewPage;
